import React from 'react';
import Text from '@baidu/icloud-ui-text';
import './OperationLink.less';
import { jsx as _jsx } from "react/jsx-runtime";
export const Operation = ({
  disabled = false,
  visible = true,
  disabledReason,
  help,
  ...props
}) => {
  if (visible) {
    return /*#__PURE__*/_jsx(Text, {
      tooltip: disabled,
      disabled: disabled,
      title: disabledReason,
      active: !disabled,
      help: help,
      ...props
    });
  }

  return null;
};
//# sourceMappingURL=es/Operation.js.map